export const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-IN'));
export const money = (v, c = 'INR') =>
  (v == null ? '—' : `${c === 'INR' ? '₹' : ''}${Number(v).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`);
export const pct = (v, digits = 0) => (v == null ? '—' : `${(v * 100).toFixed(digits)}%`);

// A ratio with no denominator is undefined, not zero. The engine returns the
// reason; printing it instead of a number is the difference between "No sales"
// and "0% ACOS", which mean opposite things.
export const ratio = (value, reason, digits = 0) =>
  (value == null ? (reason || '—') : `${(value * 100).toFixed(digits)}%`);

export const PRIORITY_TONE = { High: 'bad', Medium: 'warn', Low: 'muted' };
export const BAND_TONE = { Good: 'good', 'Needs work': 'warn', Poor: 'bad' };
export const STATE_TONE = { Ready: 'good', 'At risk': 'warn', 'Not ready': 'bad' };
export const LABEL_TONE = {
  Healthy: 'good', Review: 'warn', 'High ACOS': 'bad', Waste: 'bad', 'Low data': 'muted',
  Strong: 'good', Optimise: 'bad', Positive: 'good', Negative: 'bad', Stable: 'muted',
  Event: 'muted',
};

// A finding type as the seller reads it. The code is never shown.
export const TYPE_LABEL = {
  WASTE_CANDIDATE: 'Bought nothing',
  OVER_TARGET_SPEND: 'Spent beyond target',
  NO_EXACT_COVERAGE: 'No exact keyword',
  MISSING_NEGATIVES: 'No negative keywords',
  KEYWORD_CANNIBALISATION: 'Bidding against yourself',
  MIXED_MATCH_TYPES: 'Mixed match types',
  BLOATED_AD_GROUP: 'Too many targets',
  AUTO_HEAVY_ACCOUNT: 'Too much on auto',
  UNADVERTISED_PRODUCT: 'Not advertised',
  INELIGIBLE_PRODUCT: 'Amazon will not advertise it',
  BUDGET_CAPPED_WINNER: 'Out of budget',
  PAUSED_WINNER: 'Paused winner',
  DEAD_TARGET: 'Target not showing',
  EMPTY_AD_GROUP: 'Empty ad group',
  INCREASE_ASIN_FOCUS: 'Deserves more focus',
  REVIEW_ASIN: 'Costing too much',
  HIGH_VALUE_LOW_SHARE: 'Winning too little of it',
  OUT_OF_STOCK: 'Out of stock',
  STOCK_OUT_RISK: 'Running out of stock',
  BUY_BOX_LOST: 'Buy Box',
  LISTING_SUPPRESSED: 'Listing suppressed',
  LOW_LISTING_QUALITY: 'Listing quality',
  PRICE_RAISED: 'Price raised',
  SEEN_NOT_CLICKED: 'Seen, not clicked',
  CLICKED_NOT_BOUGHT: 'Clicked, not bought',
  WRONG_SHOPPERS: 'Wrong shoppers',
};
